<template>

  <div class="container-fluid" style="">
    <!--<div class="row" style="padding-top: 1em">-->
    <div v-if="stopUpdate || UnameOfGroup()"></div>
    <br>
    <form class="form-horizontal">
      <div class="form-group">
        <label class="control-label col-sm-2" for="name">{{$t('pages.adminpanel.group.editName')}}:</label>
        <div class="col-sm-10">
          <input type="text" id='name' class="form-control" v-model="groupName">
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2" for="surname">{{$t('pages.adminpanel.group.editDescription')}}:</label>
        <div class="col-sm-10">
          <input type="text" id='surname' class="form-control" v-model="groupDesc">
        </div>
      </div>
      <!-- <div class="form-group">
        <label class="control-label col-sm-2" for="coverURL">{{$t('pages.adminpanel.group.editCover')}}:</label>
        <div class="col-sm-10">
          <input type="coverURL" id='coverURL' class="form-control" v-model="groupa.coverUrl">
        </div>
      </div> -->
      <div class="form-group">
        <label class="control-label col-sm-2" for="locale">{{ $t('pages.adminpanel.group.color') }}:</label>
        <div class="col-sm-10">
          <select class="form-control" v-model="groupa.group.color">
            <option v-for="barva in possibleColors">
              <div :style="{'color': barva}">{{barva}}</div>
            </option>
          </select>
        </div>
      </div>
      <!-- <div class="checkbox text-center">
        <label>
          <input v-model="group.public" type="checkbox"> {{$t('pages.adminpanel.group.public')}}
        </label>
      </div> -->
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10">
          <button v-if="!isReadOnly" @click.prevent.stop="save" class="btn btn-app pull-right">
            <i class="fa fa-save"></i>{{Save}}
          </button>
          <a v-if="isReadOnly" @click.prevent.stop="save" class="btn btn-app pull-right">
            <i class="fa fa-edit"></i>{{Edit}}
          </a>
          <!-- TODO potrebne spremembe na backendu -->
          <a v-if="this.groupa.id != ''" class="btn btn-danger pull-left" @click.prevent.stop="deleteGroup()">
            <i class="fa fa-trash"></i>
          </a>
        </div>
        <div class="col-sm-offset-2 col-sm-10">
          <div class="pull-right">
            <a class="btn btn-box-tool" @click.prevent.stop="closeDropdown()">
              <i class="fa fa-caret-up"></i>
            </a>
          </div>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
// import Vue from 'vue'
import Rest from './../../services/rest'
import { mapState } from 'vuex'
// import router from './../../router/router'
export default {
  data () {
    return {
      groupId: '',
      groupName: '',
      groupDesc: '',
      coverURL: '',
      isReadOnly: true,
      glyphSectionClosed: 'glyphicon glyphicon-triangle-right',
      glyphSectionOpen: 'glyphicon glyphicon-triangle-down',
      groupList: '',
      groupEdit: '',
      groupPublic: false,
      stopUpdate: false,
      Edit: this.$t('pages.buttons.edit'),
      Save: this.$t('pages.buttons.save')
    }
  },
  props: {
    group: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      possibleColors: state => state.possibleColors,
      nameOfGroup: state => state.selectedGroup.group.name,
      groupa: state => state.selectedGroup
    }),
    isPanel () {
      return this.$route.name === 'admin'
    }
  },
  methods: {
    edit: function () {
      this.isReadOnly = false
    },
    save: function () {
      this.isReadOnly = true
      var tren = this
      var postdata = {
        name: this.groupName,
        description: this.groupDesc,
        color: this.groupa.group.color
      }
      return Rest.request('PUT', '/groups/' + this.groupa.group.id, postdata).then((data) => {
        tren.Edit = tren.$t('pages.buttons.success')
        this.group.showEdit = false
        this.$store.commit('toggleEditGroup')
        this.$store.dispatch('getGroupsNew')
        this.$store.commit('updateSelectedGroupObj', {'key': 'group', 'value': data})
      }).catch((err) => {
        console.log(err)
        tren.Edit = tren.$t('pages.buttons.fail')
      })
    },
    getGroup (name) {
      // for (let i = 0; i < this.groupList.myGroups.length; i++) {
      //   if (this.groupList.myGroups[i].name === name) return this.groupList.myGroups[i]
      // }
      // for (let i = 0; i < this.groupList.otherGroups.length; i++) {
      //   if (this.groupList.otherGroups[i].name === name) return this.groupList.otherGroups[i]
      // }
      // for (let i = 0; i < this.groupList.archived.length; i++) {
      //   if (this.groupList.archived[i].name === name) return this.groupList.archived[i]
      // }
    },
    deleteGroup: function () {
      var answer = confirm('Are you sure?')
      if (answer) {
        var tren = this
        return Rest.request('DELETE', '/groups/' + this.group.groupId).then((data) => {
          tren.groupName = ''
          tren.groupDesc = ''
          tren.coverURL = ''
          tren.groupId = ''
          this.$store.dispatch('getGroupsNew').then((data) => {
            this.$store.commit('toggleEditGroup')
            this.$store.commit('updateSelectedGroup') // update group selecetion
            this.$store.commit('updateSelectedYear') // update group selecetion
          }).catch((err) => {
            console.log(err)
          })
          // this.$store.commit('changeDeleteRefreshAdminpanel', !tren.$store.state.adminpanel.deleteRefresh)
          // tren.$store.state.adminpanel.deleteRefresh = !tren.$store.state.adminpanel.deleteRefresh
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    updateEdit (group) {
      if (group) {
        this.groupName = group.groupName
        this.groupDesc = group.groupDescription
        this.coverURL = group.coverUrl
        this.groupId = group.groupId
        this.groupPublic = group.public
        this.stopUpdate = true
      }
    },
    groupEdit (val) {
      this.updateEdit(this.getGroup(val))
    },
    UnameOfGroup () {
      if (this.nameOfGroup === '') return false
      this.updateEdit(this.getGroup(this.nameOfGroup))
      this.edit()
      return true
    },
    closeDropdown () {
      if (this.isPanel) this.$store.commit('toggleEditGroup')
      else this.$set(this.group, 'showEdit', !this.group.showEdit)
    }
  },
  created () {
    this.groupName = this.$options.filters.pickTranslation(this.groupa.group.name)
    this.groupDesc = this.$options.filters.pickTranslation(this.groupa.group.description)
  },
  watch: {
    groupEdit (val) {
      this.updateEdit(this.getGroup(val))
    },
    groupa: {
      handler (val) {
        this.$set(this.group, 'groupColor', val.group.color)
      },
      deep: true
    }
  }
}
</script>

<style scoped>

/*<!-- SASS styling -->*/
/*<style lang="scss">*/
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: #f1eff7; /* ali lightcyan*/
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }

  .fa-caret-up {
    color: white
  }
</style>



// WEBPACK FOOTER //
// EditGroup.vue?ddbbc452